import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { AttachmentDocHoc, AttachmentImageVideoHoc, AttachMusicHoc } from "../../../../../../assets/images";
import "./Attachement.scss";
import { blockOfflineMsgAction } from "../../../../../../Helpers/Utility";
import CustomIcon from "../../../../../../assets/images/CustomIcon";
import { useSelector } from "react-redux";

const Attachement = (props = {}) => {
    const State = useSelector(state => state);
    const { dynamicIcon : {data} } = State;
    const { mf_AttachMusic, mf_AttachmentDoc, mf_AttachmentImageVideo } = data;
    const audioupload = React.useRef(null);
    const documentupload = React.useRef(null);
    const imageVideoupload = React.useRef(null);
    const {
        selectFile = () => { },
        // toggleCamera = () => { },
        closeAttachment = () => { },
        imageAttachmentFlag = true,
        videoAttachmentFlag = true,
        audioAttachmentFlag = true,
        docAttachmentFlag = true
    } = props;
    const [attachement, setAttachement] = React.useState({
        showAvailableOptions: true,
        dropStatus: false,
        selectedFiles: [],
        showPreview: false,
        selectedSlide: 0,
        openCamera: false,
    });

    const { showAvailableOptions } = attachement;
    const handleOnKeyPress = (event = {}) => {
        if (event.keyCode === 27) {
            closeAttachment();
        }
    };

    /*

    // const closeCamera = () => {
    //     setAttachement({
    //         ...attachement,
    //         openCamera: false,
    //         showAvailableOptions: !showAvailableOptions
    //     },
    //         () => {
    //             onclose();
    //         }
    //     );
    // };

    // const handleClickUpload = () =>{
    //     console.log(imageVideoupload,"imageVideoupload")
    // }

    */

    const handleSelectFile = (event, type) => {
        selectFile(event, type);
        closeAttachment()
    };

    const handleFocusBack = () => {
        window.removeEventListener("focus", handleFocusBack);
        closeAttachment()
    };

    const clickedFileInput = (e) => {
        e.target.value = "";
        window.addEventListener("focus", handleFocusBack);
    };

    React.useEffect(() => {
        document && document.addEventListener("keydown", handleOnKeyPress, false);
        document &&  document.getElementById("msgContent").classList.add("bg-overlay");
        imageVideoupload.current.addEventListener("input", (e)=>handleSelectFile(e,"imagevideo"));
        documentupload.current.addEventListener("input", (e)=>handleSelectFile(e,"file"));
        audioupload.current.addEventListener("input", (e)=>handleSelectFile(e,"audio"))
        return (() => {
            document &&  document.removeEventListener("keydown", handleOnKeyPress, false);
            document &&  document.getElementById("msgContent").classList.remove("bg-overlay");
        });

    }, []);

    return (
        <div>
            <OutsideClickHandler
                onOutsideClick={() => {
                    setTimeout(() => {
                        closeAttachment();
                    }, 100);
                }}
            >
                {showAvailableOptions && (
                    <div className="choose-upload-files">
                        <ul className="fileicon">
                            {audioAttachmentFlag && 
                            <li>
                                {" "}
                                <div
                                    onClick={() => {
                                        if (blockOfflineMsgAction()) return;
                                        audioupload.current.click();
                                        setAttachement({ ...attachement, showAvailableOptions: false });
                                    }}
                                >
                                    <i className="Attach-icon-music">
                                    <CustomIcon
                                    icon={mf_AttachMusic !== "" ? mf_AttachMusic : <AttachMusicHoc viewBox="0 0 36.297 31.833"/> }
                                    {...props}
                                />
                                    </i>
                                    <span>Audio</span>
                                </div>
                            </li>}
                            { docAttachmentFlag && <li>
                                {" "}
                                <div
                                    onClick={() => {
                                        if (blockOfflineMsgAction()) return;
                                        documentupload.current.click();
                                        setAttachement({ ...attachement, showAvailableOptions: false });
                                    }}
                                >
                                    <i className="Attach-icon-doc">
                                    <CustomIcon
                                    icon={mf_AttachmentDoc !== "" ? mf_AttachmentDoc : <AttachmentDocHoc viewBox="0 0 30.3 33.752" /> }
                                    {...props}
                                    />
                                    </i>
                                    <span>Document</span>
                                </div>
                            </li>
                                }
                            {(imageAttachmentFlag || videoAttachmentFlag )&&
                                <li>
                                    {" "}
                                    <div 
                                    // onClick={handleClickUpload}
                                        onClick={() => {
                                            if (blockOfflineMsgAction()) return;
                                            imageVideoupload.current.click();
                                            setAttachement({ ...attachement, showAvailableOptions: false });
                                        }}
                                    >
                                        <i className="Attach-icon-videoImage">
                                        <CustomIcon
                                        icon={mf_AttachmentImageVideo !== "" ? mf_AttachmentImageVideo : <AttachmentImageVideoHoc viewBox="0 0 36 33" /> }
                                        {...props}
                                        />
                                        </i>
                                        {imageAttachmentFlag && videoAttachmentFlag && <span>Photo / Video</span>}
                                        {!imageAttachmentFlag && videoAttachmentFlag && <span> Video</span>}
                                        {imageAttachmentFlag && !videoAttachmentFlag && <span> Photo</span>}

                                    </div>
                                </li>
                                }   
                            {/** 
                            <li>
                                {" "}
                                <div onClick={() => {
                                    if (blockOfflineMsgAction()) return;
                                    toggleCamera()
                                }}>
                                    <i className="Attach-icon-camera">
                                    <CustomIcon
                                    icon={mf_AttachmentCamera !== "" ? mf_AttachmentCamera : <AttachmentCameraHoc viewBox="0 0 36.2 33.285" /> }
                                    {...props}
                                    />
                                    </i>
                                    <span>Camera</span>
                                </div>
                            </li> 
                            */}
                        </ul>
                    </div>
                )}
            </OutsideClickHandler>
            <input
                id="imageVideoInput"
                type="file"
                ref={imageVideoupload}
                style={{ display: "none" }}
                onChange={(e) => handleSelectFile(e, "imagevideo")}
                onClick={clickedFileInput}
                accept={
                    imageAttachmentFlag && videoAttachmentFlag && ".webm,.mp4,.x-m4v,.png,.jpeg,.jpg,video/x-m4v" ||
                    !imageAttachmentFlag && videoAttachmentFlag && ".mp4,.x-m4v,video/x-m4v,.webm" ||
                    imageAttachmentFlag && !videoAttachmentFlag && ".png,.jpeg,.jpg"
                }
                multiple
            />
            <input
                id="fileInput"
                type="file"
                ref={documentupload}
                style={{ display: "none" }}
                onChange={(e) => handleSelectFile(e, "file")}
                onClick={clickedFileInput}
                accept={
                    ".pdf,.xlsx,.xls,.txt,.doc, .docx, text/plain, .csv, .ppt, .zip, .rar, .pptx"
                }
                multiple
            />
            <input
                id="audioInput"
                type="file"
                ref={audioupload}
                style={{ display: "none" }}
                onChange={(e) => handleSelectFile(e, "audio")}
                onClick={clickedFileInput}
                accept={
                    ".wav,.mp3,.aac"
                }
                multiple
            />
        </div>
    );
}

export default Attachement;